/* eslint-disable react/prop-types */
import { Drawer, Descriptions, Tabs, Collapse, Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const { Panel } = Collapse;
const { useBreakpoint } = Grid;
const { Title } = Typography;

const PaymentDetailsDrawer = ({ payment, onClose }) => {
  const { t } = useTranslation('chargingHistoryPage');
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const tabItems = [
    {
      key: '1',
      label: t('General Information'),
      children: (
        <Descriptions bordered column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }} size="small" labelStyle={{ fontWeight: 600 }}>
          <Descriptions.Item label={t('Date')}>
            {payment.created_at}
          </Descriptions.Item>
          <Descriptions.Item label={t('Type')}>{payment.type}</Descriptions.Item>
          <Descriptions.Item label={t('Platform')}>
            {payment.platform}
          </Descriptions.Item>
          <Descriptions.Item label={t('Source')}>
            {payment.source}
          </Descriptions.Item>
          <Descriptions.Item label={t('Amount')}>
            {payment.amount}
          </Descriptions.Item>
          <Descriptions.Item label={t('Status')}>
            {payment.status ? t(payment.status, { defaultValue: payment.status }) : 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label={t('Charging History OCPP ID')}>
            {payment.chargingHistoryOcppId}
          </Descriptions.Item>
          <Descriptions.Item label={t('Payment Gateway Message')}>
            {payment.paymentGatewayMessage}
          </Descriptions.Item>
          <Descriptions.Item label={t('Payment Gateway Transaction ID')}>
            {payment.paymentGatewayTransactionId}
          </Descriptions.Item>
          <Descriptions.Item label={t('Quote ID')} span={2}>
            {payment.quoteId}
          </Descriptions.Item>
        </Descriptions>
      ),
    },
    {
      key: '2',
      label: t('Payment Gateway Response'),
      children: (
        <Collapse>
          <Panel header="paymentGatewayResponseSuccessData" key="1">
            <pre>
              {JSON.stringify(
                payment.paymentGatewayResponseSuccessData,
                null,
                2
              )}
            </pre>
          </Panel>
          <Panel header="paymentGatewayResponseData" key="2">
            <pre className="">
              {JSON.stringify(payment.paymentGatewayResponseData, null, 2)}
            </pre>
            <p style={{ color: 'red', marginTop: '10px' }}>
              <strong>{t('doNotClickUrlNote')}</strong>
            </p>
          </Panel>
        </Collapse>
      ),
    },
  ];

  return (
    <Drawer
      title={<Title level={4} className="mb-0!">{t('PaymentDetails')}</Title>}
      open={!!payment}
      onClose={onClose}
      width={isMobile ? '100%' : 800}
    >
      <Tabs defaultActiveKey="1" items={tabItems} />
    </Drawer>
  );
};

PaymentDetailsDrawer.propTypes = {
  payment: PropTypes.shape({
    paymentGatewayTransactionId: PropTypes.string,
    quoteId: PropTypes.string,
    created_at: PropTypes.string,
    type: PropTypes.string,
    paymentGatewayResponseData: PropTypes.object,
    paymentGatewayMessage: PropTypes.string,
    source: PropTypes.string,
    status: PropTypes.string,
    platform: PropTypes.string,
    paymentGatewayResponseSuccessData: PropTypes.object,
    chargingHistoryOcppId: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PaymentDetailsDrawer;
